<div class="pricing-backdrop">
  <div class="pricing-modal">

	 <button class="close-btn" aria-label="Close" (click)="close()">
      <i class="bi bi-x-lg"></i>
    </button>

    <div class="top-icon">
   <i class="bi bi-check2-circle check"></i>
    </div>

    <h2 class="title text-center">Payment Successful!</h2>
    <p class="text-center">Your Starter Learning Plan is now active.</p>
    <div class="feature">
      <div class="paid">
        <h5>Amount Paid</h5>
        <h6><i class="bi bi-currency-rupee"></i> {{finalAmount}}</h6>
      </div>
    </div>

    <button class="btn-add w-100" (click)="goToHome()">Start learning</button>
  </div>
</div>